import * as React from "react";
import {Chip, Typography} from "@mui/material";
import {styles} from "./LeadPipelineStyles";

export default function LeadPipelineCardDetails({lead, stage, showsCommercialChannel}) {
    const style = styles();
    const daysInCurrentStageLabel = `${lead.daysInCurrentStage} ${lead.daysInCurrentStage === 1 ? 'día' : 'días'} en la etapa`;

    return (
        <>
            <Typography sx={[style.cardName, style.cardNameToneOfStage(stage)]}>{lead.fantasyName}</Typography>
            <Typography sx={style.cardDetail}>{lead.responsibleName}</Typography>
            <Typography sx={style.cardDetail}>{daysInCurrentStageLabel}</Typography>
            {showsCommercialChannel && (
                <Chip size="small" label={lead.commercialChannel} sx={[style.cardChannelTag, style.channelTagToneOf(lead.commercialChannel)]}/>
            )}
        </>
    );
}
